import firebase from 'firebase';


const configOptions = {
  apiKey: 'AIzaSyCt163Hj21Ebig33DDaYUm2RXBBLNbKNFc',
  authDomain: 'stroybots-prod.firebaseapp.com',
  databaseURL: 'https://stroybots-prod.firebaseio.com',
  projectId: 'stroybots-prod',
  storageBucket: 'stroybots-prod.appspot.com',
  messagingSenderId: '326501786024',
  appId: '1:326501786024:web:6822c24b695e4a19d6bd9ds',
  measurementId: 'G-DSGR1M5854',
};
export const apiUrl = 'https://us-central1-stroybots-prod.cloudfunctions.net';

// export const apiUrl = 'https://functions-app.stroybots.ru:9099'
//
// const configOptions = {
//   apiKey: 'AIzaSyA-gD8ddrSFxAt5i17BpYyIGr2f0ajWhmE',
//   authDomain: 'fir-stroybots.firebaseapp.com',
//   databaseURL: 'https://fir-stroybots.firebaseio.com',
//   projectId: 'fir-stroybots',
//   storageBucket: 'fir-stroybots.appspot.com',
//   messagingSenderId: '873263126271',
//   appId: '1:873263126271:web:fc7ce7630e41d652915eca',
//   measurementId: 'G-7ZY6BYNB9F',
// };
// export const apiUrl = 'https://us-central1-fir-stroybots.cloudfunctions.net';

firebase.initializeApp(configOptions);

// const firebaseConfig = {
//   projectId: 'stroybots-prod',
// };
// firebase.initializeApp(firebaseConfig);
// const database = firebase.firestore();
// database.useEmulator("functions-app.stroybots.ru", 8080);
//
// const authentication = firebase.auth();
//
// authentication.useEmulator("http://functions-app.stroybots.ru:9099");

// var db = firebase.firestore();
// db.useEmulator("functions-app.stroybots.ru", 8080);
// firebase.functions().useEmulator("functions-app.stroybots.ru", 5001);
// const auth = firebase.auth();
// auth.useEmulator("https://functions-app.stroybots.ru:9099");

export default firebase;



// WEBPACK FOOTER //
// ./src/plugins/firebase.js